// src/pages/DeveloperToolsPage.js
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ThemeCtx } from "../App";
import { DatabaseIcon, Table2Icon, Upload, KeyRound, Settings2 } from "lucide-react";
import "../App.css";

export default function DeveloperToolsPage() {
  const nav = useNavigate();
  const { theme, setTheme } = useContext(ThemeCtx);

  const tiles = [
    {
      to: "/admin/dbs",
      label: "Database Settings",
      sub: "Registry, paths, active DBs",
      icon: DatabaseIcon,
    },
    {
      to: "/admin/schema",
      label: "Schema Manager",
      sub: "Edit tables & columns",
      icon: Table2Icon,
    },
    {
      to: "/admin/import",
      label: "Inventory Importer",
      sub: "Upload spreadsheets -> tables",
      icon: Upload,
    },
    {
      to: "/admin/api-keys",
      label: "API Keys",
      sub: "Manage integrations",
      icon: KeyRound,
    },
    {
      to: "/admin/settings",
      label: "System Settings",
      sub: "Environment & feature flags",
      icon: Settings2,
    },
  ];

  return (
    <div className="container">
      <div className="splash">
        <div style={{ width: "100%" }}>
          <div
            className="row"
            style={{
              justifyContent: "space-between",
              alignItems: "center",
              gap: 12,
              flexWrap: "wrap",
            }}
          >
            <div>
              <div className="splash-title">Developer Tools</div>
              <div className="splash-sub">
                Imports • DB registry • Schema • API keys • System settings
              </div>
            </div>

            <div className="row" style={{ gap: 10, flexWrap: "wrap", justifyContent: "flex-end" }}>
              <div className="row" style={{ gap: 8, alignItems: "center" }}>
                <select
                  className="input"
                  style={{ width: 150 }}
                  value={theme}
                  onChange={(e) => setTheme(e.target.value)}
                  title="Theme"
                >
                  <option value="system">System</option>
                  <option value="light">Light</option>
                  <option value="dark">Dark</option>
                </select>
              </div>
              <button className="btn-outline" onClick={() => nav("/admin")}>
                Admin
              </button>
              <button className="btn-outline" onClick={() => nav("/home")}>
                Home
              </button>
            </div>
          </div>

          <div className="scan-grid" style={{ marginTop: 16 }}>
            {tiles.map((t) => {
              const Icon = t.icon;
              return (
                <button key={t.label} className="scan-tile" onClick={() => nav(t.to)}>
                  <div className="scan-tile-top">
                    <div className="scan-icon">
                      <Icon size={22} />
                    </div>
                    <div className="scan-chev">↗</div>
                  </div>
                  <div className="scan-title">{t.label}</div>
                  <div className="scan-sub">{t.sub}</div>
                </button>
              );
            })}
          </div>

          <div className="muted" style={{ marginTop: 14 }}>
            Tip: choose the Inventory Importer to refresh tables from the latest spreadsheet before schema edits.
          </div>
        </div>
      </div>
    </div>
  );
}
